<h4 mat-dialog-title style="margin-bottom: 17px;">Add New Level</h4>
<ngx-spinner type="ball-scale-multiple" size="medium" [name]="blockLoader"></ngx-spinner>

<div mat-dialog-content class="">
	<div class="hierarchy-values" style="margin-top: 10px;
	margin-bottom: 18px;">
		<!-- <mat-label>Level Name</mat-label> -->
		<input placeholder="Level Name" class="input" matInput type="text" [(ngModel)]="levelName" name="levelName">
	</div>

	<!-- <div class="hierarchy-values  add_row" *ngFor="let value of values; let i = index; trackBy: hierarchyValueTracker">
		<input  matInput type="text" placeholder="Hierarchy Value" [(ngModel)]="values[i]" class="hierarchy-value input2">
		<button mat-raised-button color="warn" (click)="removeHierarchyValue(i)" class="remove-val-btn">Remove
			Value</button>

	</div> -->
</div>

<div mat-dialog-actions style="column-gap: 20px;
    display: flex;
    justify-content: center;">
	<!-- <div class="hierarchy-btns-row">
		<button style="width: 102px; color: white; background-color: #ffc850;" mat-raised-button  (click)="addHierarchyValue()">Add Value</button>
	</div> -->
	<button style="width: 102px" mat-raised-button color="primary" (click)="saveNewLevel()" [disabled]="isSaveDisabled()">Save</button>
</div>